import React, { useContext, useEffect, useState } from "react";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../../../Services/ApiServices/AuthService";
import { ProfileContext } from "../../../Services/ProfileProvider";

const Login = () => {

    const [formData, setFormData] = useState({ emailId: "", password: "" });
    const [showPass, setshowPass] = useState(false);
    const navigate = useNavigate();
    const { setLoginDetails } = useContext(ProfileContext);

    const handleInput = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    
    const handleSpaces = (e) => {
        if (e.key === ' ') {
            e.preventDefault();
        };
    };


    const handleLogin = async () => {
        if (!formData.emailId || !formData.password) {
            alertErrorMessage("Please enter both email and password");
            return
        } 
        try {
            const result = await AuthService.login(formData.emailId, formData.password);
            if (result?.success) {
                alertSuccessMessage(result?.message);
                setLoginDetails(result.token);
                sessionStorage.setItem("token", result?.token);
                sessionStorage.setItem("emailId", result?.data.emailId);
                sessionStorage.setItem("user_id", result?.data.user_id);
                navigate("/dashboard")
            } else {
                alertErrorMessage(result);
            };
        } catch (error) {
            alertErrorMessage(error);
        }
    };

    useEffect(() => {
        const enterToLogin = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                handleLogin();
            };
        };
        document.addEventListener('keydown', enterToLogin);
        return () => {
            document.removeEventListener('keydown', enterToLogin);
        };
    });

    return (
        <section className="section-padding login_sec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-12 mx-auto">
                        <div className=" text-center  mb-4"><img src="assets/images/logo.svg" className="navbar-brand" /></div>
                        <form className="custom-form ticket-form mb-5 mb-lg-0 ">
                            <div className="login_form" >
                                <div className=" d-block text-center mb-5">
                                    <h2 className="mb-1">  <strong className=" "> Welcome Back!</strong> </h2>
                                    <p> Please Sign in to continue</p>
                                </div>
                                <div className=" cfield_group login_group">
                                    <label className="mb-2"> Email  </label>
                                    <div className="cfield mb-3">
                                        <input type="text" className="form-control" name="emailId" placeholder="Enter Email" value={formData.emailId.toLowerCase()} onChange={handleInput} onKeyDown={handleSpaces} />
                                    </div>
                                </div>
                                <div className=" cfield_group login_group">
                                    <label className="mb-2">  Password </label>
                                    <div className="cfield mb-3 ">
                                        <div className=" field-otp-box">
                                            <input type={showPass ? 'text' : "password"} name="password" id="password" className="form-control" placeholder="Password"
                                                value={formData.password} onChange={handleInput} onKeyDown={handleSpaces}
                                            />
                                            <button type="button" class="btn btn-icon btn_view_pass btn-white" onClick={() => { setshowPass(!showPass) }}>
                                                <i className={`ri-eye${showPass ? "-line" : "-off-line"}`} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="cfield_group login_group text-end">
                                    <Link className=" mb-2" to="/forgot_password"> Forgot Password.?</Link>
                                </div>
                                <button type="button" className="btn custom-btn btn-gradient btn-border  w-100 mt-3" onClick={handleLogin}><span>LOG IN</span></button>
                            </div>
                            <div className="col-12 text-center mt-2">
                                <p>Create a New VRFX Account.? <Link className="fw-bold" to="/signup" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Register</Link></p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Login


